import React from "react";

const DiscoverIcon = () => (
  <svg
    width="80"
    height="13"
    viewBox="0 0 80 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_3363)">
      <path
        d="M42.2426 0.0551758C38.4954 0.0551758 35.4551 2.88721 35.4551 6.3824C35.4551 10.0986 38.3634 12.8764 42.2426 12.8764C46.0251 12.8764 49.0116 10.0617 49.0116 6.45541C49.0116 2.87043 46.0451 0.0551758 42.2426 0.0551758Z"
        fill="url(#paint0_linear_1_3363)"
      />
      <path
        d="M3.70945 0.285849H0.0605469V12.5987H3.69039C5.61633 12.5987 7.00914 12.1573 8.23102 11.178C9.6807 10.0148 10.5404 8.2609 10.5404 6.44815C10.5404 2.81299 7.73336 0.285849 3.70945 0.285849ZM6.61133 9.53354C5.8268 10.2183 4.81664 10.5143 3.21133 10.5143H2.54445V2.37084H3.21133C4.81664 2.37084 5.78805 2.64807 6.61133 3.3673C7.46992 4.10588 7.98195 5.24958 7.98195 6.43062C7.98195 7.61422 7.46992 8.79783 6.61133 9.53354ZM11.6863 12.5987H14.1663V0.285849H11.6866L11.6863 12.5987ZM20.2376 5.00893C18.7471 4.47472 18.3085 4.12236 18.3085 3.46012C18.3085 2.68405 19.0895 2.09376 20.1599 2.09376C20.9041 2.09376 21.5148 2.38898 22.1655 3.08841L23.4616 1.44784C22.3929 0.541315 21.1146 0.0804193 19.7201 0.0804193C17.4704 0.0804193 15.7515 1.59507 15.7515 3.60554C15.7515 5.30551 16.5524 6.17243 18.8815 6.9869C19.8552 7.31749 20.3502 7.53803 20.599 7.68874C21.0951 8.00271 21.3443 8.44426 21.3443 8.96078C21.3443 9.95936 20.5229 10.6967 19.4145 10.6967C18.231 10.6967 17.2779 10.125 16.7051 9.05435L15.1038 10.5515C16.2466 12.1739 17.621 12.8963 19.5123 12.8963C22.0885 12.8963 23.9004 11.2325 23.9004 8.85149C23.9004 6.89408 23.0629 6.00721 20.2376 5.00893ZM24.6826 6.4483C24.6826 10.0709 27.6226 12.8765 31.4023 12.8765C32.4709 12.8765 33.3868 12.6721 34.514 12.1571V9.33083C33.5202 10.2919 32.6421 10.6786 31.5155 10.6786C29.0162 10.6786 27.2401 8.9242 27.2401 6.43062C27.2401 4.06855 29.0716 2.2035 31.4023 2.2035C32.5837 2.2035 33.4821 2.60937 34.514 3.58785V0.761861C33.4262 0.228256 32.5277 0.00816345 31.459 0.00816345C27.6985 0.00816345 24.6826 2.87043 24.6826 6.4483ZM54.6282 8.55672L51.2309 0.285849H48.5205L53.9237 12.9132H55.2585L60.7559 0.285698H58.0657L54.6282 8.55672ZM61.8845 12.5988H68.9259V10.5143H64.3651V7.18855H68.7513V5.10371H64.3651V2.37069H68.9259V0.286001H61.8843L61.8845 12.5988ZM78.7523 3.91965C78.7523 1.61306 77.1132 0.285849 74.2487 0.285849H70.5648V12.5987H73.0484V7.65005H73.3734L76.807 12.5987H79.8607L75.8502 7.41227C77.7234 7.04162 78.7523 5.80405 78.7523 3.91965ZM73.7707 5.95309H73.0484V2.22209H73.8104C75.3596 2.22209 76.199 2.85169 76.199 4.04995C76.199 5.28601 75.3596 5.95309 73.7707 5.95309Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_3363"
        x1="36.1904"
        y1="0.295449"
        x2="47.8442"
        y2="13.3535"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F34F26" />
        <stop offset="1" stopColor="#F69E35" />
      </linearGradient>
      <clipPath id="clip0_1_3363">
        <rect width="80" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DiscoverIcon;
